import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect, useLocation, matchPath } from 'react-router';
import AppList from './List';
import View from './View';
import { Http } from '../../helpers/axois';
import { DeploymentUpdateVerison } from '../../helpers/RxServices';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedApp, updateAppBranch } from '../../stateManager/store/apps/actions'

const Apps: React.FC = () => {
    const dispatch = useDispatch();
    const pathname = useLocation().pathname

    const getAppId: any = matchPath(pathname, {
        path: "/apps/list/:appId/",
        exact: false,
        strict: false
    })

    const appId = getAppId && getAppId.params && getAppId.params.appId
    const selectedOrg = useSelector((state: any) => state.org.selectedOrg);
    const selectedBranch = useSelector((state: any) => state.apps.appBranch);
    const appVersion = useSelector((state: any) => state.apps.appVersion?.[appId]);

    const branchId = selectedBranch?.[appId]?.branchId;
    
    const [appDetails, setAppDetails] = useState<any>(null);
    
    useEffect(() => {
        const subscription = DeploymentUpdateVerison.getMessage().subscribe((data: any) => {
            if (data.message === 'appSwitched') {
                getCurrentApp(true);
            } else if (data.message === 'versionSwitched') {
                updateVersion(data.data);
            } else {
                getCurrentApp(false);
            }
        });
    
        return () => subscription.unsubscribe();
    }, [appVersion, branchId]);

    useEffect(() => {
        getCurrentApp(false);
    }, [appId, selectedOrg]);

    const updateVersion = (data: any) => {
        if (appDetails && appDetails[0]) {
            setAppDetails([
                {
                    ...appDetails[0],
                    versionTag: data.versionTag === 'latest' ? '' : data.versionTag,
                    versionCode: data.versionCode,
                    version_id: data.versionId
                }
            ])
        }
    }

    const getCurrentApp = async (update: boolean) => {
        const currentBranchVal = selectedBranch && selectedBranch[appId]
        if ((appId && !appDetails && selectedOrg?.id) || update) {
            try {
                const res: any = await Http.get(`org/${selectedOrg.id}/apps/${appId}`).toPromise()
                if (res.length) {
                    dispatch(updateSelectedApp({
                        id: res[0].appId,
                        name: res[0].name,
                        type: res[0].type,
                        permissions: res[0].permissions,
                        chatType: res[0].chat_type,
                        displayName: res[0].displayName
                    }));

                    const appDetails = [{
                        ...res[0],
                        versionTag: res[0].branches?.[0]?.["f4"],
                        versionCode: res[0].branches?.[0]?.["f3"],
                        version_id: res[0].branches?.[0]?.["f5"]
                    }];

                    setAppDetails(appDetails);

                    dispatch(updateAppBranch({
                        key: res[0]?.appId,
                        value: {
                            branchName: currentBranchVal.branchName,
                            branchId: currentBranchVal.branchId
                        }
                    }));
                }
            } catch (err) {
                console.error("Error fetching app details", err);
            }
        } else if(!appId && appDetails){
            setAppDetails(null);
        }
    };

    return (
        <Switch>
            <Route path="/apps/list/:appId" render={() => appDetails && <View appDetails={appDetails} />} />
            <Route path="/apps/list" component={AppList} />
            <Route path="/apps" component={() => <Redirect to="/apps/list" />} />
        </Switch>
    );
};

export default Apps;